<template>
  <ul class="nav nav-pills mb-2" id="pills-tab" role="tablist">
    <li v-for="(item, key) in areaGroup" class="nav-item">
      <button
        class="nav-link temperatureCurve-pills"
        :id="'temperatureCurve-' + key + '-tab'"
        data-bs-toggle="pill"
        :data-bs-target="'#temperatureCurve-' + key"
        type="button"
        role="tab"
        :aria-controls="'temperatureCurve-' + key"
        aria-selected="true"
        @click="pillsIndex = key"
        :class="{ active: pillsIndex == key }"
      >
        {{ item.name }}
      </button>
    </li>
  </ul>
  <div class="tab-content">
    <div
      v-for="(item, key) in areaGroup"
      class="tab-pane fade"
      :class="{
        'show active': pillsIndex == key,
      }"
      :id="'temperatureCurve-' + key"
      role="tabpanel"
      :aria-labelledby="'temperatureCurve-' + key + '-tab'"
      @click="getTempInquireData(deviceName, areaQty, firstTime, lastTime)"
    >
      <chart
        v-if="pillsIndex == key"
        :chartId="'temperatureCurve-chart-' + key"
        :styleGroup="{
          width: '100%',
          height: '250px',
          background: '#fff',
        }"
        :chartData="item.chartData"
        :chartType="'customize'"
      />
    </div>
    <commonModal :modalShow="modalShow" :size="'xl'">
      <template v-slot:modalheader>
        <button type="button" class="close" @click="modalShow = false">
          ×
        </button>
      </template>
      <template v-slot:default>
        <tempInquire
          :inquireFields="inquireFields"
          :inquireItems="inquireItems"
        />
      </template>
    </commonModal>
  </div>
</template>

<script>
import chart from "@/components/chart.vue";
import commonModal from "@/components/commonModal.vue";
import tempInquire from "@/components/tempInquire.vue";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  props: {
    areaGroup: {
      type: Array,
      default: [
        {
          name: "一區",
          chartData: {
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: [],
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        },
        {
          name: "二區",
          chartData: {
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: [],
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        },
        {
          name: "三區",
          chartData: {
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: [],
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        },
        {
          name: "四區",
          chartData: {
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: [],
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        },
      ],
    },
    deviceName: {
      type: String,
      default: "",
    },
    areaQty: {
      type: Number,
      default: 0,
    },
    firstTime: {
      type: String,
      default: "",
    },
    lastTime: {
      type: String,
      default: "",
    },
  },
  components: {
    chart,
    commonModal,
    tempInquire,
  },
  setup(props) {
    const store = useStore();

    const commonMethods = inject("commonMethods");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
    };

    const pillsIndex = ref();
    const modalShow = ref(false);
    const inquireFields = ref([]);
    const inquireItems = ref([]);

    setTimeout(() => {
      pillsIndex.value = 0;
    }, 500);

    // 取得溫度查詢的資料
    const getTempInquireData = (deviceName, areaQty, firstTime, lastTime) => {
      if (props.areaGroup == undefined) {
        return;
      }
      var params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "machstatus";
      params["device_name"] = deviceName;
      params["areaQty"] = areaQty;
      params["firstTime"] = firstTime;
      params["lastTime"] = lastTime;
      params["methods"] = "POST";
      params["whichFunction"] = "QueryTempInquireData";
      console.log(params);
      methods.axiosAction(params).then(() => {
        var result = axiosResult.value;
        if (result["Response"] == "ok") {
          inquireItems.value = result["QueryTableData"];
          let newInquireFields = ["", ""];
          for (let i = 1; i <= props.areaQty; i++) {
            newInquireFields.push(
              commonMethods.convertToTraditionalChineseNumber(i) + "區"
            );
          }
          inquireFields.value = newInquireFields;
          modalShow.value = true;
        } else {
          console.log(result);
          inquireItems.value = [];
          inquireFields.value = [];
        }
      });
    };

    watch(modalShow, (newValue) => {
      if (newValue == false) {
        inquireItems.value = [];
        inquireFields.value = [];
      }
    });
    return {
      pillsIndex,
      modalShow,
      getTempInquireData,
      inquireFields,
      inquireItems,
    };
  },
};
</script>

<style scoped>
.temperatureCurve-pills {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-status-secondary-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 6rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin-right: 0.5rem;
  cursor: pointer;
}
.nav-pills .nav-link.active.temperatureCurve-pills {
  background-color: var(--main-bg-color);
}
</style>
